module.exports = __webpack_public_path__ + "static/media/screenshot-flexcast.0fb7c28e.png";